import { Typography } from "@mui/material";
import { ethers } from "ethers";
import { LoadingButton } from "@mui/lab";
import * as React from "react";
import { MetamaskIcon } from "../resources/Icons";
import { useRecoilState } from "recoil";
import { currentMetamaskAddress } from "../store/metamask.store";

interface IMetamaskButtonProps {
  onAddressChanged?: (address: string | null) => void;
  className?: string;
}

function MetamaskButton(props: IMetamaskButtonProps) {
  const [buttonDisabled, setButtonDisabled] = React.useState(false);
  const [accountAddr, setAccountAddr] = useRecoilState(currentMetamaskAddress);
  const [networkId, setNetworkId] = React.useState<number>();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if ((window as any).ethereum && (window as any).ethereum.isMetaMask) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, []);

  React.useEffect(() => {
    if (props.onAddressChanged) props.onAddressChanged(accountAddr);
  }, [accountAddr]);

  const handleButtonClick = async () => {
    setLoading(true);
    try {
      let provider = new ethers.providers.Web3Provider((window as any).ethereum);
      let accounts: string[] = await provider.send("eth_requestAccounts", []);
      setAccountAddr(accounts[0]);

      (window as any).ethereum.on("accountsChanged", function (accounts: string[]) {
        if (accounts[0]) setAccountAddr(accounts[0]);
        else setAccountAddr(null);
      });
      setNetworkId((await provider.getNetwork()).chainId);
      (window as any).ethereum.on("chainChanged", function (networkId: number) {
        setNetworkId(networkId);
      });
    } catch (ex) {
      console.log(ex);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="MetamaskButton" style={{ marginTop: 25 }}>
      {accountAddr !== null ? (
        <>
          <Typography variant="subtitle1" style={{ color: "white" }}>
            You are currently connected as
          </Typography>
          <Typography variant="subtitle1" style={{ color: "white", fontSize: 20, overflowWrap: "break-word" }}>
            {accountAddr}
          </Typography>{" "}
        </>
      ) : (
        <LoadingButton
          endIcon={<img style={{ width: 26 }} hidden={loading || accountAddr !== null} src={MetamaskIcon} />}
          loading={loading}
          disabled={buttonDisabled || accountAddr !== null}
          onClick={handleButtonClick}
          sx={{
            backgroundColor: "#EAC249",
            color: "black",
            padding: "12px",
            "&:hover": {
              background: "#F7E6B3",
            },
          }}>
          Connect your Metamask Wallet
        </LoadingButton>
      )}

      {buttonDisabled && (
        <Typography variant="h6" style={{ color: "red", marginTop: 5 }}>
          Ups! It looks like you do not have Metamask installed. Please do so before you proceed.
        </Typography>
      )}
    </div>
  );
}

export default MetamaskButton;
